import { Requests } from '@nx-smartmonkey/shared/helpers';

import { RouteSurvey } from '../../domain/route/RouteSurvey';
import { RouteSurveyMapper } from '../../mappers/RouteSurveyMapper';
import { SessionRepository } from '../session/SessionRepository';
import { RouteSurveyRepository } from './RouteSurveyRepository';

export class RouteSurveyRepositoryApi implements RouteSurveyRepository {
  constructor(private requests: Requests, private sessionRepository: SessionRepository) {}

  async create({
    rating,
    comments,
    routeId,
  }: {
    rating: number;
    comments?: string;
    routeId: string;
  }): Promise<RouteSurvey> {
    const response = await this.requests.post({
      uri: `/drivers/v3/route/${routeId}/survey`,
      data: {
        rating,
        comments,
      },
      headers: await this.sessionRepository.getAuthenticationHeader(),
    });
    return RouteSurveyMapper.toDomain(response.data);
  }

  async update({
    rating,
    comments,
    routeId,
  }: {
    rating: number;
    comments: string;
    routeId: string;
  }): Promise<RouteSurvey> {
    const response = await this.requests.put({
      uri: `/drivers/v3/route/${routeId}/survey`,
      data: {
        rating,
        comments,
      },
      headers: await this.sessionRepository.getAuthenticationHeader(),
    });
    return RouteSurveyMapper.toDomain(response.data);
  }
}
